module.exports = __webpack_public_path__ + "static/board-05-5aad48b1b1cfccf7f4ddab076f72d778.jpg";